
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { usePipelinesStore } from '@/store/pipelines/pipelines.store';
import { useFormContext } from 'react-hook-form'




const DealPipelineField = () => {
    const useFormReturn = useFormContext();
    const { control, watch, setValue } = useFormReturn;
    const entities = usePipelinesStore((s) => s.entities);
    const pipelines = Object.values(entities);
    const { pipeline } = watch();


    return (
        <FormField
            control={control}
            name="pipeline"
            render={({ field }) => {
                const handlePipelineChange = (pipelineId: number) => {
                    field.onChange(pipelineId);
                    // Reset status when pipeline changes and set to first status of new pipeline
                    const selectedPipeline = entities[pipelineId];
                    if (selectedPipeline && selectedPipeline.status && selectedPipeline.status.length > 0) {
                        setValue("status", selectedPipeline.status[0].id);
                    } else {
                        setValue("status", undefined);
                    }
                };

                return (
                    <FormItem>
                        <FormLabel className="mb-2 block text-[10.5px] font-medium uppercase tracking-[0.12em] text-slate-500">
                            Pipeline <span className="text-accent-red">*</span>
                        </FormLabel>
                        <FormControl>
                            <Select
                                onValueChange={(val) => handlePipelineChange(Number(val))}
                                value={pipeline ? `${pipeline}` : ""}
                            >
                            <SelectTrigger className="h-9 rounded-lg border-white/[0.08] bg-white/[0.02] text-[12.5px] text-slate-200">
                                <SelectValue placeholder="Select Pipeline" />
                            </SelectTrigger>
                            <SelectContent className="rounded-xl border-white/[0.08] bg-ink-800/95 text-slate-200 shadow-card backdrop-blur-xl">
                                {pipelines.map((p) => (
                                    <SelectItem key={p.id} value={p.id.toString()} className="text-[12.5px]">
                                        {p.name}
                                    </SelectItem>
                                ))}
                            </SelectContent>
                        </Select>
                    </FormControl>
                    <FormMessage className="text-[10.5px] text-accent-red" />
                </FormItem>
                );
            }}
        />
    )
}

export default DealPipelineField
